import { IsInt, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';

export class BillingSubscriptionCheckUniqueDto {
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsNotEmpty()
  @IsInt()
  @Type(() => Number)
  billingProductId: string;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  id?: number;
}